module.exports = __webpack_public_path__ + "static/media/favorite_icon.56538d5e.png";